<script lang="ts">
	import DynamicPicture from "../Picture/DynamicPicture.svelte";
	import translations from "../../templates/Contact.translations.json";
	import type { Contact } from "../../../../core/schema/Contact.js";
	import { nbspify } from "../../../../core/utils/nbspify.js";
	import { getTranslate } from "../../utils/getTranslate.js";
	import { formatPhoneNumber } from "../../../../core/utils/formatPhoneNumber";

	export let contact: Contact;

	const translate = getTranslate(translations);
</script>

<div class="border-lttertiary -mt-px flex w-full flex-col border-b border-l border-r border-t lg:border-r-0">
	<div class="h-64 w-full overflow-hidden">
		<DynamicPicture
			bucket="storage"
			imgClass="size-full object-cover object-[center_20%]"
			class="relative size-full"
			loading="lazy"
			image={contact.image}
			width={0}
			height={256}
			alt={contact.name}
		/>
	</div>

	<div>
		<div class="border-lttertiary border-b p-8">
			<h3 class="text-ltprimary text-2lg/none font-lexend mb-0 font-normal tracking-[0.02em]">
				{nbspify(contact.name)}
			</h3>
			<span class="mt-2 block text-base/[1.6] font-normal uppercase tracking-[0.02em] text-black">
				{nbspify(contact.position)}
			</span>
		</div>

		{#if contact.email}
			<div class="p-8">
				<p class="!my-0 block text-base/[1.6] font-normal uppercase tracking-[0.02em] text-black">
					{translate("email")}
				</p>
				<a href="mailto:{contact.email}" class="text-ltprimary text-base font-medium tracking-[0.02em]">
					{nbspify(contact.email)}
				</a>
			</div>
		{/if}

		{#if contact.phone}
			<div class="border-lttertiary border-t p-8">
				<p class="!my-0 block text-base/[1.6] font-normal uppercase tracking-[0.02em] text-black">
					{translate("phone")}
				</p>
				<a href="tel:{contact.phone}" class="text-ltprimary text-base font-medium tracking-[0.02em]">
					{formatPhoneNumber(contact.phone)}
				</a>
			</div>
		{/if}
	</div>
</div>
